// extracted by mini-css-extract-plugin
module.exports = {"svg":"svg--oqQh4"};